import { forwardRef } from "react";
import { Field, Input as GardenInput } from "@zendeskgarden/react-forms";
import type { FormInputProps } from "./Interfaces";
import { useInput } from "./useInput";

export const Input = forwardRef<HTMLInputElement, FormInputProps>(
  (
    {
      id,
      name,
      label,
      hint,
      message,
      validation,
      error,
      className,
      wrapperClassName,
      onValueChange,
      onChange,
      onBlur,
      ...rest
    },
    ref
  ) => {
    const { inputId, finalMessage, finalValidation, handleChange } = useInput({
      id,
      error,
      message,
      validation,
      onChange,
      onValueChange,
    });

    const { type, ...inputProps } = rest;
    const mergedClassName = [className, type === "date" ? "date-input" : ""]
      .filter(Boolean)
      .join(" ");

    return (
      <Field className={wrapperClassName}>
        {label && <Field.Label htmlFor={inputId}>{label}</Field.Label>}

        <GardenInput
          id={inputId}
          name={name}
          ref={ref}
          className={mergedClassName}
          type={type}
          onChange={handleChange}
          onBlur={onBlur}
          {...inputProps}
        />

        {hint && <Field.Hint>{hint}</Field.Hint>}
        {finalMessage && <Field.Message validation={finalValidation}>{finalMessage}</Field.Message>}
      </Field>
    );
  }
);

Input.displayName = "Input";
export default Input;
